import { SubSection } from "context/BlogContext";
import React from "react";

interface PreviewListProps {
  subSection: SubSection;
}

const PreviewList: React.FC<PreviewListProps> = ({ subSection }) => {
  return (
    <div>
      {subSection.type === "list" && (
        <div className="pt-5">
          {subSection.title && <p className="pt-3">{subSection.title}</p>}
          <p className="">
            {subSection.attrs?.style === "ordered" ? (
              <ul className="list-decimal list-inside rounded-md">
                {subSection.attrs.items.map((item: string, index: number) => (
                  <li className={`${index !== 0 ? "pt-2" : ""}`} key={index}>
                    {item}
                  </li>
                ))}
              </ul>
            ) : (
              <ul className="list-disc list-inside rounded-md">
                {subSection.attrs.items.map((item: string, index: number) => (
                  <li className="pt-2" key={index}>
                    {item}
                  </li>
                ))}
              </ul>
            )}
          </p>
        </div>
      )}
    </div>
  );
};

export default PreviewList;
